import { useEffect, useState } from 'react'

import { PAGE_CONTAINER_HOST } from '../constants'
import { getFontSizeByPageStyle } from '../utils'

/**
 * 获取html fontsize
 * @date 2024/3/29 - 17:26:28
 *
 * @returns {*}
 */
export const useMediaQueryRemBase = () => {
    const [remBase, setRemBase] = useState(getFontSizeByPageStyle)

    useEffect(() => {
        // 如果是管理端， 监听模拟器的变化，否则监听根节点的resize变化
        const simulatorDom = document.querySelector(PAGE_CONTAINER_HOST)
        if (simulatorDom) {
            const observer = new MutationObserver(() => {
                setRemBase(getFontSizeByPageStyle)
            })
            observer.observe(document.documentElement, { attributeFilter: ['style'] })

            return () => {
                observer.disconnect()
            }
        }
    }, [])

    return remBase
}

export type EndPoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
const getEndPoints = (windowSize: number): { query: boolean; endpoint: EndPoint }[] => [
    {
        query: windowSize <= 736,
        endpoint: 'xs'
    },
    {
        query: windowSize > 736 && windowSize <= 980,
        endpoint: 'sm'
    },
    {
        query: windowSize > 980 && windowSize <= 1280,
        endpoint: 'md'
    },
    {
        query: windowSize > 1280 && windowSize <= 1680,
        endpoint: 'lg'
    },
    {
        query: windowSize > 1680,
        endpoint: 'xl'
    }
]

/**
 * 手动设置remBase
 * @date 2024/3/29 - 17:26:28
 *
 * @returns {*}
 */

const setRemBaseSize = (containerDom?: HTMLElement) => {
    const simulatorDom = containerDom ?? document.querySelector<HTMLDivElement>(PAGE_CONTAINER_HOST)
    if (!simulatorDom) {
        return 'xl'
    }

    const windowSize = simulatorDom.clientWidth
    if (windowSize === 0) {
        return
    }
    const endPoints = getEndPoints(windowSize).find(item => item.query)
    document.documentElement.style.fontSize = `${windowSize / 60}px`

    return endPoints?.endpoint ?? 'xl'
}

export const useManualSetMediaQueryRemBase = (): EndPoint => {
    const [endpoint, setEndpoint] = useState('xl')
    // 首次设值
    useEffect(() => {
        const endpoint = setRemBaseSize()
        if (!endpoint) {
            return
        }
        setEndpoint(endpoint)
    }, [])

    // 监听容器 resize
    useEffect(() => {
        const simulatorDom = document.querySelector<HTMLDivElement>(PAGE_CONTAINER_HOST)
        if (!simulatorDom) {
            return
        }
        const observer = new ResizeObserver(() => {
            const endpoint = setRemBaseSize(simulatorDom)
            if (!endpoint) {
                return
            }
            setEndpoint(endpoint)
        })
        observer.observe(simulatorDom)
        return () => {
            observer.disconnect()
        }
    }, [])

    return endpoint as EndPoint
}
